import { GiftGuard } from 'src/app/guards/gift/gift.guard';
import { TrashGuard } from 'src/app/guards/trash/trash.guard';
import { CheckinGuard } from 'src/app/guards/checkin/checkin.guard';
import { NgModule } from '@angular/core';
import { redirectUnauthorizedTo, AngularFireAuthGuard } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { AccountGuard } from 'src/app/guards/account/account.guard';
import { GuestGuard } from 'src/app/guards/guest/guest.guard';
import { UserGuard } from 'src/app/guards/user/user.guard';
import { TabsPage } from './tabs.page';

/**
 * Redirect unauthorize access to root
 */
const redirectUnauthorizedToRoot = () => redirectUnauthorizedTo(['main']);

const routes: Routes = [
  {
    path: 'tabs-user',
    component: TabsPage,
    children: [
      {
        path: '',
        redirectTo: 'profile',
        pathMatch: 'full'
      },
      {
        path: 'profile',
        loadChildren: () => import('src/app/pages/user/user-profile/user-profile.module').then( m => m.UserProfilePageModule)
      }
    ]
  },
  {
    path: 'tabs-accounts',
    component: TabsPage,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        loadChildren: () => import('src/app/pages/accounts/accounts-list/accounts-list.module').then( m => m.AccountsListPageModule)
      },
      {
        path: 'list/:addNew',
        loadChildren: () => import('src/app/pages/accounts/accounts-list/accounts-list.module').then( m => m.AccountsListPageModule)
      },
      {
        path: 'inbox',
        loadChildren: () => import('src/app/pages/inbox/inbox-home/inbox-home.module').then( m => m.InboxHomePageModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('src/app/pages/user/user-profile/user-profile.module').then( m => m.UserProfilePageModule)
      }
    ]
  },
  {
    path: 'tabs-guest',
    component: TabsPage,
    canActivate: [ AngularFireAuthGuard, UserGuard ],
    data: {
      authGuardPipe: redirectUnauthorizedToRoot,
    },
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('src/app/pages/guest/guest-home/guest-home.module').then( m => m.GuestHomePageModule)
      },
      {
        path: 'list',
        loadChildren: () => import('src/app/pages/guest/guest-list/guest-list.module').then( m => m.GuestListPageModule)
      },
      {
        path: 'new',
        loadChildren: () => import('src/app/pages/guest/guest-new/guest-new.module').then( m => m.GuestNewPageModule)
      },
      {
        path: 'new/:type',
        loadChildren: () => import('src/app/pages/guest/guest-new/guest-new.module').then( m => m.GuestNewPageModule)
      },
      {
        path: 'qrcode',
        loadChildren: () => import('src/app/pages/guest/guest-qrcode/guest-qrcode.module').then( m => m.GuestQrcodePageModule)
      },
      {
        path: 'qrcode/:settingType',
        loadChildren: () => import('src/app/pages/guest/guest-qrcode/guest-qrcode.module').then( m => m.GuestQrcodePageModule)
      },
      {
        path: 'seating',
        loadChildren: () => import('src/app/pages/guest/guest-seating/guest-seating.module').then( m => m.GuestSeatPageModule)
      }
    ]
  },
  {
    path: 'tabs-checkin',
    component: TabsPage,
    canActivate: [ AngularFireAuthGuard, UserGuard ],
    data: {
      authGuardPipe: redirectUnauthorizedToRoot,
    },
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('src/app/pages/checkin/checkin-home/checkin-home.module').then( m => m.CheckinHomePageModule)
      },
      {
        path: 'list',
        loadChildren: () => import('src/app/pages/checkin/checkin-list/checkin-list.module').then( m => m.CheckinListPageModule)
      },
      {
        path: 'scan',
        loadChildren: () => import('src/app/pages/checkin/checkin-scan/checkin-scan.module').then( m => m.CheckinScanPageModule)
      },
      {
        path: 'seating',
        loadChildren: () => import('src/app/pages/checkin/checkin-seating/checkin-seating.module').then( m => m.CheckinSeatingPageModule)
      },
      {
        path: 'new',
        loadChildren: () => import('src/app/pages/checkin/checkin-new/checkin-new.module').then( m => m.CheckinNewPageModule)
      }
    ]
  },
  {
    path: 'tabs-gift',
    component: TabsPage,
    canActivate: [ AngularFireAuthGuard, UserGuard ],
    data: {
      authGuardPipe: redirectUnauthorizedToRoot,
    },
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('src/app/pages/gift/gift-home/gift-home.module').then( m => m.GiftHomePageModule)
      },
      {
        path: 'list',
        loadChildren: () => import('src/app/pages/gift/gift-list/gift-list.module').then( m => m.GiftListPageModule)
      },
      {
        path: 'guest',
        loadChildren: () => import('src/app/pages/gift/gift-guest/gift-guest.module').then( m => m.GiftGuestPageModule)
      },
      {
        path: 'seating',
        loadChildren: () => import('src/app/pages/gift/gift-seating/gift-seating.module').then( m => m.GiftSeatingPageModule)
      },
      {
        path: 'new',
        loadChildren: () => import('src/app/pages/gift/gift-new/gift-new.module').then( m => m.GiftNewPageModule)
      }
    ]
  },
  {
    path: 'tabs-account',
    canActivate: [ AngularFireAuthGuard, UserGuard ],
    data: {
      authGuardPipe: redirectUnauthorizedToRoot,
    },
    component: TabsPage,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('src/app/pages/account/account-home/account-home.module').then( m => m.AccountHomePageModule)
      }
    ]
  },
  {
    path: 'tabs-trash',
    canActivate: [ AngularFireAuthGuard, UserGuard ],
    data: {
      authGuardPipe: redirectUnauthorizedToRoot,
    },
    component: TabsPage,
    children: [
      {
        path: '',
        redirectTo: 'guest',
        pathMatch: 'full'
      },
      {
        path: 'guest',
        loadChildren: () => import('src/app/pages/guest/guest-list/guest-list.module')
        .then( m => m.GuestListPageModule)
      },
      {
        path: 'gift',
        loadChildren: () => import('src/app/pages/gift/gift-list/gift-list.module').then( m => m.GiftListPageModule)
      }
    ]
  },

  {
    path: '',
    redirectTo: '/main',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TabsPageRoutingModule {}
